import React from 'react';
import './Banner.css';
import bannerImage from '../../../assets/Banner/Md_Yeasin.JPG';
import { FaLinkedin, FaGithub, FaTwitter, FaDiscord } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const Banner = () => {
    return (
        <div className="py-10">
            <div className="md:flex justify-center items-center">
                <img src={bannerImage} alt="" className="my-image" />
                <div className="my-info">
                    <h1 className="my-name">Md Yeasin</h1>
                    <h2 className="my-designation">Frontend Web Developer</h2>
                </div>
            </div>
            <p className="about-me text-center">
                {/* I'm Yeasin, a Frontend Web Developer. I lvoe to do code when coding other thing . */}
                I'm Yeasin, a MERN Stack Web Developer.
                Try to solve real life problems using programming which impacts human life.
                I am coming here because of my passion and I want to do something remarkable with it.
                Have advanced knowledge about Frontend Development focused on React.
                Also have a comportable idea about the backend with node.
                Explore new technology daily to build a strong knowledge of full stack development.
                Now I'm acquiring deep knowledge about MERN Stack.
            </p>
            <div className="flex justify-center my-5">
                <Link to="https://discord.com/users/874667456633905192" target="_blank"><FaDiscord className="mx-3" /></Link>
                <Link to="https://github.com/mdYeasin-cmd" target="_blank"><FaGithub className="mx-3" /></Link>
                <Link to="https://www.linkedin.com/in/md-yeasin-b755141b9/" target="_blank"><FaLinkedin className="mx-3" /></Link>

            </div>
            <div className='text-center'>
                <a href="https://drive.google.com/file/d/1VeJzwtgRCPE8-uV7yrQCeDNdOyY2loIE/view?usp=share_link">
                    <button className="btn bg-[#6DC17B] text-black">Resume</button>
                </a>
            </div>
        </div>
    );
};

export default Banner;